import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Input,
  Row,
} from "reactstrap";
import PlacesAutocomplete from "react-places-autocomplete";
import countries from "i18n-iso-countries";

import * as items from "i18n-iso-countries/langs/en.json";
import LocationSuggestions from "./LocationSuggestions";
import classNames from "classnames";
import { handleLocationSelection } from "./LocationHelperFunctions";

countries.registerLocale(items);

const LocationInputDropdown = ({
  location,
  setLocation,
  onReset,
  searchText,
  setSearchText,
  isEditing,
  setIsEditing,
  processingLocation,
  setIsGoogleLocation,
}) => {
  const isEditingExisting = !!location?.id;

  const Buttons = (
    <>
      <Button
        size="sm"
        color="danger"
        outline
        onClick={onReset}
        className="btn-icon-only mr-0 pr-0 ml-2"
        disabled={false}
      >
        <i className={`mdi mdi-close`} />
      </Button>
    </>
  );

  if (!isEditing) {
    return (
      <div className="d-flex align-items-center ml-2 mb-2 mr-2">
        <div
          className="border rounded py-2 pl-2 pr-4 bg-superlight w-100 text-dark text-truncate cursor-pointer font-weight-500"
          style={{ position: "relative" }}
          onClick={() => setIsEditing(true)}
        >
          {searchText}
          <i
            className="mdi mdi-pencil ml-2"
            style={{ position: "absolute", right: 6, fontSize: 14 }}
          />
        </div>
        {location.Readable && Buttons}
      </div>
    );
  }

  return (
    <PlacesAutocomplete
      value={searchText ?? ""}
      onChange={setSearchText}
      onSelect={(v) => handleSelect(v)}
      highlightFirstSuggestion
      debounce={500}
    >
      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
        <Card className="mb-0">
          <CardHeader className="px-2 pt-0 pb-2 border-lighter">
            <Row className="align-items-center">
              <Col xs="auto" className="pr-2" style={{ lineHeight: 1 }}>
                {!location.Address.Address1 &&
                !location.Address.Address2 &&
                !location.Address.City &&
                !location.Address.StateProvince &&
                !location.Address.StreetNumber &&
                !location.Address.ZipCode &&
                location.Address.CountryCode2 ? (
                  <div
                    className="d-inline-block border border-light"
                    style={{
                      lineHeight: 1,
                      position: "relative",
                      top: 0,
                      borderRadius: 2,
                    }}
                  >
                    <div
                      style={{
                        width: 20,
                        height: 20,
                        marginBottom: -2,
                      }}
                      className={`d-inline-block flag:${location.Address.CountryCode2}`}
                    ></div>
                  </div>
                ) : (
                  <div style={{ width: 22 }}>
                    <i
                      className="mdi mdi-map-marker text-dark pl-1"
                      style={{ fontSize: 20, lineHeight: 1 }}
                    ></i>
                  </div>
                )}
              </Col>
              <Col
                xs=""
                className={`pl-0 d-flex`}
                style={{ width: "calc(100% - 128px)" }}
              >
                <Input
                  bsSize="sm"
                  className="form-control"
                  {...getInputProps({
                    placeholder: "Enter Address...",
                  })}
                />
                {location.Readable && Buttons}
              </Col>
            </Row>
          </CardHeader>
          <CardBody
            className={classNames("p-0", { border: suggestions?.length > 0 })}
            style={{
              zIndex: 99999,
              position: "absolute",
              top: 30,
              left: 25,
              width: "calc(100% - 65px)",
            }}
          >
            <LocationSuggestions
              suggestions={suggestions}
              loading={loading}
              getSuggestionItemProps={getSuggestionItemProps}
            />
          </CardBody>
        </Card>
      )}
    </PlacesAutocomplete>
  );

  async function handleSelect(value) {
    const newLocation = await handleLocationSelection(value);

    setSearchText(value);
    setIsEditing(false);
    setIsGoogleLocation(true);

    setLocation((prevState) => ({
      ...prevState,
      ...newLocation,
    }));
  }
};

export default LocationInputDropdown;
